module.exports = __webpack_public_path__ + "static/media/derrybros.e6523859.png";